
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/syarat-dan-ketentuan",
      function () {
        return require("private-next-pages/syarat-dan-ketentuan.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/syarat-dan-ketentuan"])
      });
    }
  